import SystemMessageModal from "@/Components/SystemMessage/SystemMessageModal";
import usePriorityModal from "@/shared/atoms/usePriorityModal";
import useIsKiosk from "@/shared/hooks/useIsKiosk";
import useIsKioskUser from "@/shared/hooks/useIsKioskUser";
import useSystemMessageSeenPost from "@/shared/mutations/systemMessages/useSystemMessageSeenPost";
import useSystemMessagesPendingQuery from "@/shared/queries/systemMessages/useSystemMessagesPendingQuery";
import { useState } from "react";
import { useLocation } from "react-router-dom";

// Screens customers or the kitchen look at, a message there would be in the way
const HIDDEN_PATHS = ["/kiosk", "/screens", "/screen/", "/orders/mimic"];

/**
 * Shows the system messages the user has not seen yet, one after the other.
 * Closing a message tells the backend it was seen so it won't come back.
 */
const SystemMessageGlobal = () => {
  const { pathname } = useLocation();
  const isKiosk = useIsKiosk();
  const isKioskUser = useIsKioskUser();
  const [{ priorityModal }] = usePriorityModal();
  const hidden =
    isKiosk || isKioskUser || HIDDEN_PATHS.some((path) => pathname.startsWith(path));

  const { data: pending = [] } = useSystemMessagesPendingQuery({ enabled: !hidden });
  const seen = useSystemMessageSeenPost();
  // Hidden right away instead of waiting for the next fetch
  const [dismissed, setDismissed] = useState<number[]>([]);

  const queue = pending.filter((message) => !dismissed.includes(message.item_id));
  const current = queue[0];

  // A payment or another priority modal goes first
  if (hidden || priorityModal || !current) return null;

  const done = () => {
    setDismissed((ids) => [...ids, current.item_id]);
    seen.mutate(current.item_id);
  };

  return (
    <SystemMessageModal
      // A fresh modal per message so the content scrolls back to the top
      key={current.item_id}
      message={current}
      position={pending.length - queue.length + 1}
      total={pending.length}
      onDone={done}
    />
  );
};

export default SystemMessageGlobal;
